import authService from './authService';

let BASE_URL = process.env.REACT_APP_API_URL

async function loadConfig() {
    try {
        const response = await fetch("/config.json");
        const config = await response.json();
        BASE_URL = config.API_URL || BASE_URL; 
        //console.log("API URL Loaded:", BASE_URL);
    } catch (error) {
        console.error("Failed to load config.json. Using default .env API URL", error);
    }
}

loadConfig().then(() => {
    //console.log("Config initialized");
});


export async function createCompliance(complianceData:any) {
 
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance`, {
        method: 'POST',
      
        body: JSON.stringify(complianceData),
      });

      if (!response.ok) {
        throw new Error('Failed to create compliance');
      }

      const result = await response.json();
      return result;
      // Optionally, navigate to another page or show a success message
    } catch (error:any) {
      console.error('Error creating compliance:', error);
      throw new Error(error);
      // Optionally, show an error message to the user
    }
  };

export async function getCompliance(query:string, perPage:number, pageNo:number) {
    try {
      const response = await authService.apiCall(`${BASE_URL}/compliance?query=${query}&perPage=${perPage}&pageNo=${pageNo}`, {
        method: 'GET',
       
      });

      if (!response.ok) {
        throw new Error('Failed to get compliance');
      }

      const result = await response.json();
      //console.log('Compliance fetched successfully:', result);
      return result;
    } catch (error) {
      console.error('Error fetching compliance:', error);
      throw new Error('Error fetching compliance');
    }

}

export async function updateComplianceStatusApi(id: string, newStatus: string,userId:any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance/${id}`, {
      method: 'PUT',
    
    body: JSON.stringify({ complianceStatus: newStatus,userId:userId }),
  });
  if (!response.ok) {
    throw new Error('Failed to update compliance status');
  }
  const result = await response.json();
  return result;
} catch (error) {
  console.error('Error updating compliance status:', error);
  throw new Error('Error updating compliance status');
}
}

export const updateCompliance = async (id: string, data: any) => {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance/updatecomplaince/${id}`, {
      method: 'PUT',
     
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update compliance');
    }

    return await response.json();
  } catch (error: any) {
    console.error('Error updating compliance:', error);
    throw error.message || 'Failed to update compliance';
  }
};


export async function getComplianceInfo(id: string) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance/${id}`, {
      method: 'GET',
     
  });
  if (!response.ok) {
    throw new Error('Failed to get compliance info');
  }
  const result = await response.json();
  return result;
} catch (error) {
  console.error('Error fetching compliance info:', error);
  throw new Error('Error fetching compliance info');
}
}


export async function getControlsWithTasks(compliance_id: any, subdomainId: any) {
  try {
    const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/compliance/${compliance_id}/domain/${subdomainId}`, {
      method: 'GET',
     
  });
  if (!response.ok) {
    throw new Error('Failed to get controls with tasks');
  }
  const result = await response.json();
  return result;
} catch (error) {
  console.error('Error fetching controls with tasks:', error);
  throw new Error('Error fetching controls with tasks');
}
}

export async function getTask(controlId:any,complianceId:any,subFieldId:any){
  try{
    const response = await authService.apiCall(`${BASE_URL}/compliance-control-actions/${controlId}/compliance/${complianceId}/domain/${subFieldId}`, {
      method: 'GET',
      
    });
    if (!response.ok) {
      throw new Error('Failed to get task');
    }
    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error fetching task:', error);
    throw new Error('Error fetching task');
  }
}